import SeoLandingPage from "@/components/SeoLandingPage";

const GitBranchPractice = () => <SeoLandingPage pageKey="gitBranchPractice" />;

export default GitBranchPractice;
